import * as React from 'react';
import { ArticleHeading2, ArticleParagraph2, ArticleParagraph3 } from '@cian/ui-kit';
import { RecommendationsToggle } from '../../RecommendationsToggle';
import { AgreementField } from '../AgreementField';
import { Button } from '../Button';
import { PhoneField } from '../PhoneField';
import { Recommendations } from '../Recommendations';
import { TimeField } from '../TimeField';
import * as styles from './CallbackFormWithRecommendations.css';
export var CallbackFormWithRecommendations = function CallbackFormWithRecommendations(_ref) {
  var callTime = _ref.callTime,
    errors = _ref.errors,
    isSubmitDisabled = _ref.isSubmitDisabled,
    isSubmitting = _ref.isSubmitting,
    onPhoneChange = _ref.onPhoneChange,
    onSubmit = _ref.onSubmit,
    onTimeChange = _ref.onTimeChange,
    onUserConfirm = _ref.onUserConfirm,
    onWithRecommendationsChange = _ref.onWithRecommendationsChange,
    phoneRef = _ref.phoneRef,
    privacyPolicyUrl = _ref.privacyPolicyUrl,
    recommendations = _ref.recommendations,
    values = _ref.values,
    isSMSDisclaimerEnabled = _ref.isSMSDisclaimerEnabled;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container'],
    "data-testid": "callback-form-with-recommendations"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['title']
  }, /*#__PURE__*/React.createElement(ArticleHeading2, {
    as: "h3"
  }, "\u0417\u0430\u043A\u0430\u0437 \u0437\u0432\u043E\u043D\u043A\u0430 \u043E\u0442 \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A\u0430")), /*#__PURE__*/React.createElement("form", {
    className: styles['form'],
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['form-block']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['fields-row']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['phone']
  }, /*#__PURE__*/React.createElement(PhoneField, {
    ref: phoneRef,
    label: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
    error: errors.phone,
    onChange: onPhoneChange,
    value: values.phone,
    disabled: isSubmitting
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['time']
  }, /*#__PURE__*/React.createElement(TimeField, {
    label: "\u0412\u0440\u0435\u043C\u044F \u0434\u043B\u044F \u0437\u0432\u043E\u043D\u043A\u0430 ",
    error: errors.time,
    onChange: onTimeChange,
    value: values.time,
    disabled: isSubmitting
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['button-wrapper']
  }, /*#__PURE__*/React.createElement(Button, {
    loading: isSubmitting,
    disabled: isSubmitDisabled,
    type: "submit"
  }, "\u041F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\u0435 \u043C\u043D\u0435")))), /*#__PURE__*/React.createElement("div", {
    className: styles['form-block']
  }, /*#__PURE__*/React.createElement(ArticleParagraph2, {
    color: errors.time ? 'error_100' : 'gray60_100'
  }, callTime)), /*#__PURE__*/React.createElement("div", {
    className: styles['form-block']
  }, /*#__PURE__*/React.createElement(AgreementField, {
    checked: values.isUserConfirmed,
    onChange: onUserConfirm,
    disabled: isSubmitting,
    privacyPolicyUrl: privacyPolicyUrl
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['recommendations']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['form-block']
  }, /*#__PURE__*/React.createElement(RecommendationsToggle, {
    onChange: onWithRecommendationsChange,
    checked: values.withRecommendations,
    disabled: isSubmitting
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['form-block']
  }, /*#__PURE__*/React.createElement(Recommendations, {
    recommendations: recommendations,
    disabled: !values.withRecommendations
  })), /*#__PURE__*/React.createElement(ArticleParagraph3, {
    color: "gray60_100"
  }, "\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u043D\u0430 \xAB\u041F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\u0435 \u043C\u043D\u0435\xBB \u0432\u044B \u0434\u0430\u0435\u0442\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u043E\u0431\u0440\u0430\u0442\u043D\u044B\u0439 \u0437\u0432\u043E\u043D\u043E\u043A \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u043C \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A\u0430\u043C", !!isSMSDisclaimerEnabled && ' и получение от Циан сообщений информационного характера о времени звонка и номере телефона застройщика'))));
};